import React, { useState } from 'react';
import { useSelector } from 'react-redux';
import { useParams } from 'react-router-dom';
import { AppModal, AppRemixIcon } from '@/layout/AppComponents';
import AppLink from '../../../../routing/helpers/AppLink';
import FolderHome from './FolderHome';
import PublicationHome from './PublicationHome';

export default function TopButtons() {
  const { moduleBridgeHex, parentItemHex } = useParams();
  const breadcrumb = useSelector((state) => state.currentPage?.breadcrumb);
  const permissionsLevel = useSelector(
    (s) => s.module[moduleBridgeHex]?.userBridge?.permissions?.level,
  );
  const [showPublicationAddModal, setShowPublicationAddModal] = useState(false);
  const [showFolderAddModal, setShowFolderAddModal] = useState(false);

  return (
    <div className="my-3">
      {permissionsLevel === 0 && (
        <>
          {breadcrumb?.length > 0 && parentItemHex !== '0' ? (
            <AppLink
              path="user_module_documentManager_item_list"
              params={{
                moduleBridgeHex,
                parentItemHex: breadcrumb?.[breadcrumb?.length - 2]?.hex || '0',
                page: 1,
                filtersHex: '0',
              }}
              className="btn btn-xs btn-outline-light d-inline-flex mr-3"
              title="Subir un nivel"
            >
              <AppRemixIcon icon="corner-right-up" className="mr-1" filled /> Subir un
              nivel
            </AppLink>
          ) : (
            <span className="btn btn-xs btn-outline-light d-inline-flex mr-3 disabled">
              <AppRemixIcon icon="corner-right-up" className="mr-1" filled /> Subir un
              nivel
            </span>
          )}
          <button
            type="button"
            className="btn btn-xs btn-outline-light d-inline-flex mr-3"
            onClick={() => setShowPublicationAddModal(true)}
            title="Añadir publicación"
          >
            <AppRemixIcon icon="add" className="mr-1" /> Publicación
          </button>
          <button
            type="button"
            className="btn btn-xs btn-outline-light d-inline-flex mr-3"
            onClick={() => setShowFolderAddModal(true)}
            title="Crear carpeta"
          >
            <AppRemixIcon icon="add" className="mr-1" /> Carpeta
          </button>
          <AppModal
            show={showPublicationAddModal}
            title="Añadir publicación"
            size="xl"
            onClose={() => setShowPublicationAddModal(false)}
            backdrop="static"
          >
            <PublicationHome onClose={() => setShowPublicationAddModal(false)} />
          </AppModal>
          <AppModal
            show={showFolderAddModal}
            title="Añadir carpeta"
            onClose={() => setShowFolderAddModal(false)}
          >
            <FolderHome onClose={() => setShowFolderAddModal(false)} />
          </AppModal>
        </>
      )}
    </div>
  );
}
